import Vue from 'vue';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    apiKey: window.bugsnag,
    plugins: [new BugsnagPluginVue(Vue)],
    enabledReleaseStages: ['production']
});
